import { URLS_CONSTANTS } from "../../config.js";
import authService from "../auth/authService";
import axios from "axios";

export default {
  id: String,
  permissionList: Array,

  async setUserPermission(id) {
    var access_token = await authService.getAccessToken();
    
    await axios
      .get(
        URLS_CONSTANTS.baseURL +
          "/IdentityAccess/api/UsersQuery/" +
          id +
          "/permissions",
        {
          headers: {
            Authorization: "Bearer" + " " + access_token
          }
        }
      )
      .then(response => {
        localStorage.setItem("permissions", response.data);
      })
      .catch(error => {
        this.errors = error.response.data;
      });
  },

  async getAllPermission() {
    var permissions = localStorage.getItem("permissions");
    this.permissionList = permissions;
    if (permissions === null) {
      var userInfo = await authService.getUser();
      await this.setUserPermission(userInfo.profile.sub);
    }
  },

  async hasPermission(meta) {
    await this.getAllPermission();
    var hasPermission = false;
    var permissions = localStorage.getItem("permissions");

    if (permissions === null) return false;
    if (meta.includes("|")) {
      meta.split("|").forEach(function(oneMeta) {
        permissions.split(",").forEach(function(permission) {
          if (permission == oneMeta) {
            hasPermission = true;
          }
        });
      });
    } else {
      permissions.split(",").forEach(function(permission) {
        if (permission == meta) {
          hasPermission = true;
        }
      });
    }
    // if (meta.toLowerCase() === permission.toLowerCase()) {
    //   hasPermission = true;
    // } else {

    //   hasPermission = false;
    // }

    return hasPermission;
  }
};
